<template>
  <component
    :is="tag"
    class="icon-button"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseIcon :name="icon" class="icon-button__svg" />
  </component>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseIconButton',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.$attrs.href) return 'router-link';
      return 'button';
    },
    attributes() {
      const { href, ...attributes } = this.$attrs;
      if (!href && !attributes.type) {
        attributes.type = 'button';
      }
      if (href) {
        attributes.to = href;
      }
      return attributes;
    },
    modifiers() {
      return {
        'icon-button_active': this.isActive,
      };
    },
  },
};
</script>

<style lang="stylus">
.icon-button
  position relative
  display flex
  align-items center
  justify-content center
  width 1.6em
  height @width
  font-family inherit
  text-decoration none
  color inherit
  background none
  padding 0
  margin 0
  border 0
  outline none

  // Чтобы в кнопку было легче попасть :)
  &:after
    content ''
    abs top left right bottom
    margin -1em

  &:hover
  //&:active
    color $c_link

  &_active
    color $c_link
    z-index 1
    &:after
      background-color $c_bg
      margin -0.6em
      border-radius 50%
      z-index -1

  &__svg
    display block
    width 100%
    height 100%
</style>
